// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.filter-input input {\n  font-size: var(--fs-input) !important;\n  color: var(--green) !important;\n  font-weight: 400 !important;\n  padding-top: 9px !important;\n  padding-bottom: 9px !important;\n}\n", ""]);
// Exports
module.exports = exports;
